import t, { useState as y, useEffect as d } from "react";
import { c as i, t as m } from "./app-a75c1d35.mjs";
import { B as s } from "./Block-9b78bd10.mjs";
import { I as G } from "./Image-d6406817.mjs";
import { L as f } from "./Link-479ac100.mjs";
import "./ImageContext-57256dc1.mjs";
import "./Image.module-8b345b58.mjs";
import "./LinkContext-0c83848a.mjs";
const L = "logo-gallery__content", _ = "logo-gallery__header", u = "logo-gallery__lead", p = "logo-gallery__list", E = "logo-gallery__list-container", I = "logo-gallery__item", h = "logo-gallery__item--link", k = "logo-gallery__image", o = {
  logoGalleryContent: L,
  logoGalleryHeader: _,
  logoGalleryLead: u,
  logoGalleryList: p,
  logoGalleryListContainer: E,
  logoGalleryItem: I,
  logoGalleryItemLink: h,
  logoGalleryImage: k
}, N = [];
function $({
  header: r,
  leadText: e,
  logos: l = N
}) {
  const [a, n] = y(() => l);
  return d(() => {
    n(C(l));
  }, [l]), !r && !e && a.length === 0 ? null : /* @__PURE__ */ t.createElement(
    s,
    {
      as: "section",
      topPadding: s.Padding.SMALL,
      bottomPadding: s.Padding.LARGE,
      "data-testid": "logo-gallery"
    },
    /* @__PURE__ */ t.createElement(s.Content, { flex: !0, className: o.logoGalleryContent }, r && /* @__PURE__ */ t.createElement(
      "h2",
      {
        className: i(
          m.headingSection,
          o.logoGalleryHeader
        ),
        "data-testid": "logo-gallery-header"
      },
      r
    ), e && /* @__PURE__ */ t.createElement(
      "p",
      {
        className: i(m.textsLeadText, o.logoGalleryLead),
        "data-testid": "logo-gallery-lead"
      },
      e
    ), a.length > 0 && /* @__PURE__ */ t.createElement("div", { className: o.logoGalleryListContainer }, /* @__PURE__ */ t.createElement(
      "ul",
      {
        className: o.logoGalleryList,
        "data-testid": "logo-gallery-list"
      },
      a.map((g, c) => /* @__PURE__ */ t.createElement("li", { key: `${g.href ?? "logo"}-${g.image.src}-${c}` }, /* @__PURE__ */ t.createElement(x, { item: g })))
    )))
  );
}
function x({ item: r }) {
  const { image: e, href: l, isExternalLink: a } = r, n = /* @__PURE__ */ t.createElement(
    G,
    {
      ...e,
      className: o.logoGalleryImage,
      altText: e.altText
    }
  );
  return l ? /* @__PURE__ */ t.createElement(
    f,
    {
      href: l,
      target: a ? "_blank" : void 0,
      disableLinkTextStyle: !0,
      className: i(o.logoGalleryItem, o.logoGalleryItemLink),
      "data-testid": "logo-gallery-item"
    },
    n
  ) : /* @__PURE__ */ t.createElement("div", { className: o.logoGalleryItem, "data-testid": "logo-gallery-item" }, n);
}
function C(r) {
  const e = [...r];
  for (let l = e.length - 1; l > 0; l -= 1) {
    const a = Math.floor(Math.random() * (l + 1)), n = e[l], g = e[a];
    n !== void 0 && g !== void 0 && (e[l] = g, e[a] = n);
  }
  return e;
}
export {
  $ as LogoGallery,
  C as shuffleArray
};
//# sourceMappingURL=LogoGallery.js.map
